import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Marina',
  city: 'Rosario',
  product: 'MegaPack Árabe PRO'
}, {
  name: 'Noelia',
  city: 'San Juan',
  product: 'MegaPack Árabe PRO'
}, {
  name: 'Luciana',
  city: 'Buenos Aires',
  product: 'MegaPack Árabe PRO'
}];
const VISIBLE_DURATION = 10000;
const HIDDEN_DURATION = 30000;
export function SocialProofToast() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return undefined;
    const timer = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        return;
      }
      setActiveIndex(current => (current + 1) % RECENT_PURCHASES.length);
      setIsVisible(true);
    }, isVisible ? VISIBLE_DURATION : HIDDEN_DURATION);
    return () => window.clearTimeout(timer);
  }, [isDismissed, isVisible]);
  if (isDismissed || !isVisible) return null;
  const purchase = RECENT_PURCHASES[activeIndex];
  return <aside key={`${purchase.name}-${purchase.city}`} className="social-proof-enter fixed bottom-3 left-3 right-3 z-50 flex max-w-sm items-start gap-3 rounded-2xl border border-gold/50 bg-ink p-3.5 shadow-[0_14px_34px_rgba(59,16,34,0.18)] sm:bottom-6 sm:left-6 sm:right-auto sm:p-4" aria-live="polite" aria-label="Compra reciente" data-id="element-322" data-mp="kdlq6eyp1vgl">
      <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-323" data-mp="yc1w43oqfhxo">
        <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-324" data-mp="13921sdho6io9" />
      </span>
      <div className="min-w-0 flex-1 pr-1" data-id="element-325" data-mp="182wug6f967zh">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-lime" data-id="element-326" data-mp="1d0ybymx15z8u">Compra reciente</p>
        <p className="mt-0.5 text-sm font-bold text-snow" data-id="element-327" data-mp="1i0ufym5q9qoe">
          {purchase.name} de {purchase.city}
        </p>
        <p className="mt-0.5 text-xs leading-snug text-snow-muted" data-id="element-328" data-mp="1m2xujjnp1bdw">
          Eligió {purchase.product} · acceso inmediato
        </p>
      </div>
      <button type="button" onClick={() => setIsDismissed(true)} className="-m-1.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-snow-dim transition-colors hover:text-snow focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" aria-label="Cerrar notificación" data-id="element-329" data-mp="3j0fs0m0tw36r">
        <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-330" data-mp="3n216gbt0gpj2" />
      </button>
    </aside>;
}